import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Section";

export default function NotFound() {
  return (
    <div className="lc-container grid min-h-[80vh] place-items-center pt-28 text-center" data-testid="not-found-page">
      <Seo title="Page not found" noindex />
      <div>
        <p className="font-display text-8xl font-extrabold text-[#FF6A00]">404</p>
        <h1 className="mt-4 font-display text-3xl font-bold">This page has gone up in smoke.</h1>
        <Link to="/" className="lc-btn-primary mt-8" data-testid="not-found-home">Back to home</Link>
      </div>
    </div>
  );
}
